import { Timestamp } from 'firebase/firestore';

export function cloneSnapshot<T>(value: T): T {
  if (value instanceof Date) return new Date(value.getTime()) as T;
  if (value instanceof Timestamp) return value;
  if (Array.isArray(value)) return value.map(cloneSnapshot) as T;
  if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value)
    .filter(([, item]) => item !== undefined).map(([key, item]) => [key, cloneSnapshot(item)])) as T;
  return value;
}

export function sameSnapshot(left: unknown, right: unknown): boolean {
  const canonical = (value: any): any => value instanceof Date ? { dateMillis: value.getTime() }
    : value instanceof Timestamp ? { seconds: value.seconds, nanoseconds: value.nanoseconds }
    : Array.isArray(value) ? value.map(canonical)
    : value && typeof value === 'object' ? Object.fromEntries(Object.keys(value).sort()
      .filter(key => value[key] !== undefined).map(key => [key, canonical(value[key])])) : value;
  return JSON.stringify(canonical(left)) === JSON.stringify(canonical(right));
}

